/* src/app/pages/order/order.page.scss */
ion-content {
  padding: 0 10px;
}
ion-footer.invalid {
  background: darkgrey;
  color: grey;
}
/*# sourceMappingURL=order.page.css.map */
